export default function TimeIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99996 9.99996H9.24996C9.24996 10.3228 9.45653 10.6094 9.76279 10.7115L9.99996 9.99996ZM10.75 5.83329C10.75 5.41908 10.4142 5.08329 9.99996 5.08329C9.58575 5.08329 9.24996 5.41908 9.24996 5.83329H9.99996H10.75ZM12.2628 11.5448C12.6557 11.6758 13.0805 11.4634 13.2115 11.0705C13.3425 10.6775 13.1301 10.2528 12.7371 10.1218L12.5 10.8333L12.2628 11.5448ZM9.99996 9.99996H10.75V5.83329H9.99996H9.24996V9.99996H9.99996ZM9.99996 9.99996L9.76279 10.7115L12.2628 11.5448L12.5 10.8333L12.7371 10.1218L10.2371 9.28845L9.99996 9.99996ZM18.3333 9.99996H17.5833C17.5833 14.1881 14.1881 17.5833 9.99996 17.5833V18.3333V19.0833C15.0165 19.0833 19.0833 15.0165 19.0833 9.99996H18.3333ZM9.99996 18.3333V17.5833C5.8118 17.5833 2.41663 14.1881 2.41663 9.99996H1.66663H0.916626C0.916626 15.0165 4.98337 19.0833 9.99996 19.0833V18.3333ZM1.66663 9.99996H2.41663C2.41663 5.8118 5.8118 2.41663 9.99996 2.41663V1.66663V0.916626C4.98337 0.916626 0.916626 4.98337 0.916626 9.99996H1.66663ZM9.99996 1.66663V2.41663C14.1881 2.41663 17.5833 5.8118 17.5833 9.99996H18.3333H19.0833C19.0833 4.98337 15.0165 0.916626 9.99996 0.916626V1.66663Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
